import { render, staticRenderFns } from "./FormBuilderPropertiesDrawer.vue?vue&type=template&id=c6eb8e02&"
import script from "./FormBuilderPropertiesDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderPropertiesDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports